export * from '@apollo/client';
export * from '@apollo/client/react/components';
export * from '@apollo/client/react/hoc';
export { onError } from '@apollo/client/link/error';
export { setContext } from '@apollo/client/link/context';
export { RetryLink } from '@apollo/client/link/retry';
export { getDataFromTree } from '@apollo/client/react/ssr';
export { InMemoryCache } from '@apollo/client/cache';
export { MockedProvider } from '@apollo/client/testing';
export * from './type-policies';
export * from './invalidation-policies';
export * from './hooks';
export { default as gql } from 'graphql-tag';
export { GraphQLError } from 'graphql'; // follows the same logic as the app-configs' browser key:
// https://github.com/NerdWallet/nwjs-app-config/blob/39f3662d5ec7701d31b1dde176ea53ecf1a2647a/src/browser-key.js

var id = process.env.BROWSER_APP_CONFIG_ID || process.env.CLIENT_ID || '';
export var BROWSER_KEY = "__APOLLO_STATE--".concat(id.toUpperCase(), "__");